/*
 * DefinitionDescriptionField.tsx
 * Un composant de champ de définition (description dd) avec un style personnalisé.
 * A utiliser avec un champ de définition (terme dt) le tout dans une liste de définitions (dl).
 */

import React from 'react';
import { Skeleton } from '@radix-ui/themes';
import '../../styles/global.css';

// Définition des props du composant
interface DefinitionDescriptionFieldProps {
	value: string | number | undefined;
	loading: boolean;
	onClick?: () => void;
	/** Lien réel : Ctrl+clic et clic molette ouvrent un nouvel onglet. */
	href?: string;
}

// DefinitionDescriptionField component
const DefinitionDescriptionField: React.FC<DefinitionDescriptionFieldProps> = ({
	value,
	loading,
	onClick,
	href,
}) => {
	// Rendu du composant
	return (
		<div>
			{loading ? (
				<Skeleton
					className="w-48 h-6 rounded block bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200"
					style={{
						backgroundSize: '200% 100%',
						animation: 'shimmer 1.5s infinite linear',
					}}
				/>
			) : (
				<dd
					onClick={href ? undefined : onClick}
					className={
						href || onClick
							? 'cursor-pointer hover:underline hover:text-blue-600'
							: 'text-gray-900'
					}
				>
					{href ? (
						<a href={href} className="hover:underline hover:text-blue-600">
							{value || '...'}
						</a>
					) : (
						value || '...'
					)}
				</dd>
			)}
		</div>
	);
};

// Export du composant
export default DefinitionDescriptionField;
